module.exports = __webpack_public_path__ + "static/img/ergeng.cf6897d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/ergeng.png
// module id = v13B
// module chunks = 1